import { queryTree, insertTree, updateTree, deleteTree, queryTreeOne, getMenuNode, getAppMenuNode, selectUserOrg } from "../../api/config/modules/tree";

const state = {
    queryTree: {},
    insertTree: {},
    updateTree: {},
    deleteTree: {},
    queryTreeOne: {},
    getMenuNode: {},
    getAppMenuNode: {},
    selectUserOrg: {}
};

const mutations = {
    SET_QUERYTREE: (state, queryTree) => {
        state.queryTree = queryTree;
    },
    SET_INSERTTREE: (state, insertTree) => {
        state.insertTree = insertTree;
    },
    SET_UPDATETREE: (state, updateTree) => {
        state.updateTree = updateTree;
    },
    SET_DELETETREE: (state, deleteTree) => {
        state.deleteTree = deleteTree;
    },
    SET_QUERYTREEONE: (state, queryTreeOne) => {
        state.queryTreeOne = queryTreeOne;
    },
    SET_GETMENUNODE: (state, getMenuNode) => {
        state.getMenuNode = getMenuNode;
    },
    SET_GETAPPMENUNODE: (state, getAppMenuNode) => {
        state.getAppMenuNode = getAppMenuNode;
    },
    SET_SELECTUSERORG: (state, selectUserOrg) => {
        state.selectUserOrg = selectUserOrg;
    },
};

const actions = {
    GET_QUERYTREE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            queryTree(data)
                .then((res) => {
                    commit("SET_QUERYTREE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTTREE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertTree(data)
                .then((res) => {
                    commit("SET_INSERTTREE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATETREE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateTree(data)
                .then((res) => {
                    commit("SET_UPDATETREE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETETREE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteTree(data)
                .then((res) => {
                    commit("SET_DELETETREE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_QUERYTREEONE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            queryTreeOne(data)
                .then((res) => {
                    commit("SET_QUERYTREEONE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETMENUNODE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getMenuNode(data)
                .then((res) => {
                    commit("SET_GETMENUNODE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETAPPMENUNODE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getAppMenuNode(data)
                .then((res) => {
                    commit("SET_GETAPPMENUNODE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTUSERORG: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectUserOrg(data)
                .then((res) => {
                    commit("SET_SELECTUSERORG", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
